import { IonIcon } from "@ionic/react";
import { chevronUpOutline } from "ionicons/icons";
import React, { useState } from "react";
import styled from "styled-components";

const CTA = styled.div<any>`
	bottom:1rem;
	height: max-content;
	width: 100%;
	background: #000;
	color: #f2f2f2;
	z-index: 105;
	padding:1rem;
	overflow:hidden;
	${props => props};
`;

const Header = styled.div`
	color: #fff;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
	text-align: left;
`;

const Content = styled.div<any>`
	color: #aaaaaa;
	font-weight: 500;
	font-size: 12px;
	text-align: left;
	margin: ${props => props.margin};
	padding: ${props => props.padding};
	line-height: 14px;
	min-height: ${props => props.minHeight};
`;

const Row = styled.div<any>`
	display: flex;
	align-items: ${props => props.center ? "center" : ""};
	width: 100%;
	gap: 1rem;
	margin:${props => props.margin};
`;

const Column = styled.div<any>`
	display: flex;
	flex-direction: column;
	gap: 0;
`;

const ArrowContainer = styled.div`
	display:flex;
	align-items:flex-start;
	margin-left:auto;
`;

const Arrow = styled(IonIcon)<any>`
	font-size: 20px;
	transition: all linear 100ms;
`;

const IconContainer = styled.div`
	display:flex;
	align-items:flex-start;
	width:25px;
	flex-shrink: 0;
`;

const Icon = styled.img`
	width:100%;
`;

const ExpandableCTA = (props: any) => {
	const { header, content, icon, customContainerStyle, defaultValue, minHeight, } = props;
	const initalValue = typeof defaultValue !== 'undefined' ? defaultValue : false;
	const [isExpanded, toggleIsExapanded] = useState(initalValue);

	return (
		<CTA {...customContainerStyle} className={'no-scrollbar'} >
				<Row>
					<IconContainer>
						<Icon src={icon} />
					</IconContainer>
					<Column >
						<Row center margin="4px 0 0 0" >
							<Header>{header}</Header>
							<ArrowContainer>
								<Arrow className={isExpanded ? "card-expanded-arrow" : ""} src={chevronUpOutline} onClick={() => toggleIsExapanded((prev:boolean) => !prev)} />
							</ArrowContainer>
						</Row>
						<Content padding="1rem 0 0 0" minHeight={minHeight} className={isExpanded ? "expandable-cta-open" : "expandable-cta-close"} >{content}</Content>
					</Column>
				</Row>
		</CTA>
	);
};

export default ExpandableCTA;
